import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import _get from 'lodash/get';
import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import TabBar from '@lib/components/TabBar/TabBar';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';
import getTabs from './utils/getTabs';

interface Props {
  formTemplateData: Values;
  linkedDocumentsCount?: number;
}

export default function FormTemplateBuilderViewMenu(props: Props) {
  const { formTemplateData, linkedDocumentsCount } = props;
  const { id, versionId } = useParams();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { getUserAccessByCompany, isFullAdmin }: ContextProps =
    useOutletContext();
  const isDocumentationLocked =
    getUserAccessByCompany(AccessComponentEnum.DocumentationManagement) ===
    AccessLevelEnum.LimitedRead;

  const tabs = getTabs({
    // Locked EDM: hide tab from non-Full-Admin users (no way to upgrade).
    // Full Admin still sees the tab and gets a lock-state render inside.
    hideLinkedDocuments: isDocumentationLocked && !isFullAdmin,
    id,
    linkedDocumentsCount,
    versionId,
    visibleLinkedTasksCount: _get(
      formTemplateData,
      'visibleLinkedTasksCount',
      0,
    ) as number,
    t,
  });

  return (
    <TabBar
      items={tabs}
      active={pathname}
      onActiveChange={(item) => navigate(item.value)}
      useSidePaddings
      bleedSidePaddings
    />
  );
}
